import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PiratesHideout4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PIRATES_HIDEOUT4;
}

export default PiratesHideout4PoiTileEntity;
